<template>
    <div>
        车辆加氢列表
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>